<h2
    mat-dialog-title
    [ngClass]="this.data.status !== 'invalid' ? 'tt-success-background' : 'tt-danger-background'"
    [ngStyle]="style['title']"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
>
    {{ this.data.status !== "invalid" ? label : translations["error"] }}
</h2>
<mat-dialog-content style="padding: 1.8rem; padding-bottom: 1rem">
    <tt-progress-bar
        ttLabelView="top"
        [ttLabel]="label"
        ttTranslateLabel="false"
        [ttModel]="data.value"
        [ttSublabel]="data.hideSublabel === true ? '' : data.value + ' av ' + data.max + ' rader lagret'"
        ttTranslateSublabel="false"
        [ttMax]="data.max"
        [ttStatus]="data.status"
        [ttIndeterminate]="data.indeterminate"
        [ttInvalidText]="data.invalidtext || ''"
        [ttStyle]="style"
    ></tt-progress-bar>
    <tt-checkbox ttLabel="finishclose" ttLabelView="top" [(ttModel)]="this.data.finishclose" (ttModelChange)="onFinishCloseChanged($event)" [ttTrueValue]="true" [ttFalseValue]="false"></tt-checkbox>
</mat-dialog-content>
<mat-dialog-actions>
    <tt-button
        *ngIf="data.disableClose !== true"
        class="col-xs-2 sp-0"
        ttText="close"
        [ttType]="this.data.status !== 'invalid' ? 'success' : 'danger'"
        (ttClick)="onClose()"
        [ttStyle]="style"
    ></tt-button>
    <!--<tt-button *ngIf="data.showCancel" class="col-xs-2 sp-0" ttText="cancel" [ttType]="'warning'" (ttClick)="onCancel()" [ttStyle]="style" style="padding-left: 0.5em"></tt-button>-->
</mat-dialog-actions>
